module.exports = __webpack_public_path__ + "img/big-logo.ccaabfda.png";